<template>
  <div>
    <v-text-field
      ref="queryNameInputField"
      v-bind:value="value"
      v-on:input.native="$emit('input', $event.target.value)"
      v-bind:label="label"
    ></v-text-field>
    <div v-show="exactMatch" class="text-xs-left mt-2 uxl-warning">
      <v-icon>warning</v-icon>
      {{ $t('modal.queryNameInput.overwriteWarning') }}
    </div>
    <div v-show="matchingQueries && matchingQueries.length > 0" class="caption text-xs-left mt-2">
      {{ $t('modal.queryNameInput.matchingNamesTitle') }}
    </div>
    <v-container class="matching-queries pt-0" v-if="matchingQueries && matchingQueries.length > 0">
      <v-layout align-center wrap>
        <v-flex xs6 v-for="query in matchingQueries" :key="query.id">
          {{query.name}}
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'QueryNameInput',
  props: ['label', 'value', 'queries', 'queryId'],
  mounted: function () {
    this.$nextTick(this.$refs.queryNameInputField.focus)
  },
  computed: {
    matchingQueries: function () {
      if (this.queries === null) {
        return null
      } else if (this.value === null || typeof this.value === 'undefined' || this.value.length <= 0) {
        return this.queries
      } else {
        const needle = this.value.toLowerCase()
        return this.queries.filter(q => {
          const haystack = q.name.toLowerCase()
          return haystack.substring(0, needle.length) === needle
        })
      }
    },
    exactMatch: function () {
      return this.value !== null &&
        typeof this.value !== 'undefined' &&
        this.matchingQueries &&
        this.matchingQueries.length >= 1 &&
        this.value === this.matchingQueries[0].name &&
        (this.queryId === null || this.queryId !== this.matchingQueries[0]._id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .matching-queries {
    height: 133px;
    overflow: scroll;
    background-color: $grey-50;
  }
  .uxl-warning, .theme--light .uxl-warning .icon {
    color: $red-500;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/QueryNameInput.vue